

















import ToolsHelper from '@core/services/tools.helper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-pos-payment-balance-details',
  components: {},
})
export default class PosPaymentBalanceDetails extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  readonly amountToBePaid!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly paymentAmount!: number;

  get differenceAmount(): number {
    return Math.max(this.amountToBePaid - this.paymentAmount, 0);
  }

  get amountToReturn(): number {
    return Math.max(this.paymentAmount - this.amountToBePaid, 0);
  }

  get paymentAmountFormatted(): string {
    return ToolsHelper.formatPrice(this.paymentAmount);
  }

  get differenceAmountFormatted(): string {
    return ToolsHelper.formatPrice(this.differenceAmount);
  }

  get amountToReturnFormatted(): string {
    return ToolsHelper.formatPrice(this.amountToReturn);
  }
}
